// extracted by mini-css-extract-plugin
export default {"dueDateOuter":"styles-module__IocIi","noDivider":"styles-module__qZG8u"};